import React, { ReactNode } from 'react';

// Material-UI
import { Box, BoxProps } from '@mui/material';

// Project Imports
import MainCard from '../../components/MainCard';

// AuthCardProps
interface AuthCardProps {
  children: ReactNode;
  // Add any other props you need here
}

const AuthCard: React.FC<AuthCardProps & BoxProps> = ({ children, ...other }) => (
  <MainCard
    sx={{
      maxWidth: { xs: 400, lg: 475 },
      margin: { xs: 2.5, md: 3 },
      '& > *': {
        flexGrow: 1,
        flexBasis: '50%'
      }
    }}
    content={false}
    {...other}
    border={false}
    boxShadow
  >
    <Box sx={{ p: { xs: 2, sm: 3, md: 4, xl: 5 } }}>{children}</Box>
  </MainCard>
);

export default AuthCard;
